const withoutPoints = [
  "You can't accurately compare scope differences",
  "You don't know where contractors are adding margin",
  "You have little leverage if something goes wrong",
];

const withPoints = [
  "Every bid is normalized and analyzed",
  "Pricing outliers are flagged immediately",
  "Contractors know they're being compared and held accountable",
];

export default function WhyChoose() {
  return (
    <section id="why-choose" className="py-24" style={{ backgroundColor: '#f0faf4' }}>
      <div className="max-w-5xl mx-auto px-6">

        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-sm font-semibold tracking-widest text-emerald-600 uppercase mb-3">
            The Advocate Advantage
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Why OverUnder<br />Changes the Outcome
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto leading-relaxed">
            Most homeowners think getting multiple bids is enough.
          </p>
          <p className="text-xl font-bold text-gray-800 mt-2">It&apos;s not.</p>
          <div className="w-20 h-1 bg-emerald-500 mx-auto rounded-full mt-6"></div>
        </div>

        {/* Two-column comparison */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

          {/* Without OverUnder */}
          <div className="bg-white border border-slate-200 rounded-2xl p-8 flex flex-col gap-5">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-rose-50 shrink-0">
                <i className="ri-close-circle-line text-2xl text-rose-500"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900">Without Expert Analysis</h3>
            </div>
            <ul className="flex flex-col gap-4">
              {withoutPoints.map((pt, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="mt-1 w-5 h-5 flex items-center justify-center shrink-0">
                    <i className="ri-close-line text-rose-400 text-lg"></i>
                  </span>
                  <p className="text-sm text-gray-600 leading-relaxed">{pt}</p>
                </li>
              ))}
            </ul>
          </div>

          {/* With OverUnder */}
          <div className="bg-emerald-700 rounded-2xl p-8 flex flex-col gap-5">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-emerald-600 shrink-0">
                <i className="ri-check-double-line text-2xl text-emerald-200"></i>
              </div>
              <h3 className="text-lg font-bold text-white">With OverUnder</h3>
            </div>
            <ul className="flex flex-col gap-4">
              {withPoints.map((pt, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="mt-1 w-5 h-5 flex items-center justify-center shrink-0">
                    <i className="ri-check-line text-emerald-300 text-lg"></i>
                  </span>
                  <p className="text-sm text-emerald-100 leading-relaxed">{pt}</p>
                </li>
              ))}
            </ul>
          </div>

        </div>

        {/* Bottom line */}
        <div className="mt-10 border border-emerald-200 bg-white rounded-2xl px-8 py-7 text-center max-w-2xl mx-auto">
          <p className="text-gray-800 text-lg leading-relaxed">
            <span className="font-black text-emerald-700">Bottom line: </span>
            You get a better roof at a better price&mdash;with{' '}
            <span className="font-bold text-gray-900">far less risk</span>.
          </p>
        </div>

      </div>
    </section>
  );
}
